export const publicLandingPreview = {
  progressDelta: '+18%',
  averageSessionTime: '11m 24s',
  averageErrorDelta: '-12%',
  progressBars: [36, 52, 41, 67, 73, 62, 84],
  recentSessions: [
    {
      patient: 'Leonardo da Vinci',
      activity: 'Trova Numeri - Medio',
      score: 'Score 92',
    },
    {
      patient: 'Marie Curie',
      activity: 'Reazione e Inibizione - Difficile',
      score: 'Score 87',
    },
    {
      patient: 'Ada Lovelace',
      activity: 'Labirinto - Medio',
      score: 'Score 89',
    },
  ],
  kpis: [
    { label: 'Pazienti attivi', value: '24' },
    { label: 'Sessioni settimana', value: '87' },
    { label: 'Aderenza media', value: '91%' },
    { label: 'Alert clinici', value: '3' },
  ],
};
